<div class="resources-list" [style]="`border-radius: ${block.data.borderRadius}`">
    @if (block.data.title) {
        <h2
            class="resources-list__title"
            [innerText]="block.data.title"
            [style.color]="titleColor"
            [style.font-size]="titleFontSize"
            [style.font-weight]="titleFontWeight"></h2>
    }
    <div class="resources-list__content">
        @for (item of block.content; track item.id) {
            @if (!item.data.showOnlyOnLinkedPages) {
                @if (item.data.file) {
                    <a
                        class="resources-list__link"
                        [href]="item.data.file.file_url || item.data.file.url"
                        target="_blank"
                        [style.color]="linkColor"
                        [style.font-size]="linkFontSize"
                        [style.font-weight]="linkFontWeight"
                        [core-analytics]="{ action: 'Download', category: 'RESOURCES', label: item.data.file.name }">
                        <span class="resources-list__text" [innerText]="item.data.text || item.data.file.name"></span>
                    </a>
                } @else if (item.data.url) {
                    <a
                        class="resources-list__link"
                        [href]="item.data.url"
                        [target]="item.data.target"
                        [class.link-ext]="item.data.target === '_blank'"
                        [style.color]="linkColor"
                        [style.font-size]="linkFontSize"
                        [style.font-weight]="linkFontWeight"
                        [core-analytics]="{
                            action: item.data.target === '_blank' ? 'External Link' : 'Internal Link',
                            category: 'RESOURCES',
                            label: item.data.title,
                        }">
                        <span class="resources-list__text" [innerText]="item.data.text"></span>
                    </a>
                }
            }
        }
    </div>
</div>
